import { toZonedTime, fromZonedTime } from 'date-fns-tz'
import { BUSINESS_TIMEZONE } from '~/data/bookerData'

export const useDateTimeService = () => {
	const businessNow = (): Date => toZonedTime(new Date(), BUSINESS_TIMEZONE)

	const toBusinessTime = (value: Date | string | number): Date => toZonedTime(new Date(value), BUSINESS_TIMEZONE)

	const toInstant = (businessDate: Date | string | number): Date => fromZonedTime(new Date(businessDate), BUSINESS_TIMEZONE)

	return { businessNow, toBusinessTime, toInstant }
}
